import * as tslib_1 from "tslib";
import { BaseComponent } from "../../base/base.component";
import * as photosphere from "../../../../assets/js/marzipano/photosphere.js";
import { MARKER_TYPE_NORTH, MARKER_TYPE_PHOTOSPHERE, MARKER_TYPE_PRODUCT, MARKER_TYPE_PROMO } from "../../../../assets/js/marzipano/properties.js";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { concatMap, finalize, map } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { LOG_EVENT_PHOTOSPHERE, LOG_EVENT_PRODUCT, LOG_EVENT_PROMOTION, SPHERE_ACTION_ARROWS, SPHERE_ACTION_PLANT, SPHERE_ACTION_PROMO, SPHERE_ACTION_REMOVE, SPHERE_ACTION_CHANGE_MARKER, SPHERE_ACTION_SHORTCUT, SPHERE_BTN_GRAY, SPHERE_BTN_BLUE, SPHERE_BTN_GREEN, SPHERE_BTN_RED, SPHERE_BTN_YELLOW, SPHERE_ACTION_CORRECT, SPHERE_ACTION_PRODUCT_LINK, LANG_CODE_IT, LANG_CODE_EN, LANG_CODE_FR, PRODUCTS_LANG_CODE_IT, PRODUCTS_LANG_CODE_EN, PRODUCTS_LANG_CODE_FR } from "../../../crossconcern/utilities/properties/base.property";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { Location } from "@angular/common";
import { LogManager } from "../../../business/managers/log.manager";
import { PRIVATE_NURSERY_MAP_ROUTE } from "../../../crossconcern/utilities/properties/routename.property";
import { GenericService } from "../../../crossconcern/services/generic.services";
import { logData } from "../../../crossconcern/helpers/generic/generic.helper";
import { MAP_INITIAL_LATITUDE, MAP_INITIAL_LONGITUDE, MAP_STYLE, PRODUCT_MARKER_PITCH_OFFSET } from "../../../crossconcern/utilities/properties/map.properties";
import { MapsAPILoader } from "@agm/core";
import { getCurrentScene } from "../../../../assets/js/marzipano/photosphere";
import { MeasureInfoModel } from "../../../datastore/entities/measureinfo.model";
var PhotosphereComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PhotosphereComponent, _super);
    function PhotosphereComponent(translate, appComponent, router, genericService, photosphereManager, logManager, location, alertUtils, mapsAPILoader) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.translate = translate;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.genericService = genericService;
        _this.photosphereManager = photosphereManager;
        _this.logManager = logManager;
        _this.location = location;
        _this.alertUtils = alertUtils;
        _this.mapsAPILoader = mapsAPILoader;
        _this.isBack = false;
        _this.sphereUUID = null;
        _this.nurseryUUID = null;
        _this.backButtons = [];
        _this.isEditing = false;
        _this.isEditingChangeMarker = false;
        _this.isEditingMarker = false;
        _this.isEditingPromoMarker = false;
        _this.isEditingPromo = false;
        _this.isEditingArrow = false;
        _this.isEditingShortcuts = false;
        _this.isEditingProductLink = false;
        _this.isNewPromo = false;
        _this.avgLat = MAP_INITIAL_LATITUDE;
        _this.zoom = 19;
        _this.avgLong = MAP_INITIAL_LONGITUDE;
        _this.dropdownSettings = {
            singleSelection: true,
            idField: "uuid",
            textField: "name",
            enableCheckAll: false,
            allowSearchFilter: true
        };
        _this.productMeasuresDropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "customText",
            enableCheckAll: false,
            allowSearchFilter: true
        };
        _this.promoDropdownSettings = {
            singleSelection: true,
            idField: "uuid",
            textField: "title",
            enableCheckAll: false,
            allowSearchFilter: true
        };
        // Array containing only the one nursery (the one with nurseryUUID)
        // Used as a frontsidebar component parameter
        _this.nurseries = [];
        _this.mapStyle = [];
        _this.mapStyle.push(MAP_STYLE);
        return _this;
    }
    PhotosphereComponent.prototype.ngOnInit = function () {
        this.appComponent.startLoading();
        this.init();
    };
    PhotosphereComponent.prototype.init = function () {
        var _this = this;
        this.subscribeGenericServices();
        this.subscribeOnLangChange();
        this.currentPhotosphereUuid = this.sphereUUID;
        this.photosphereManager.getProducts()
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }), concatMap(function (res) {
            _this.products = res;
            _this.translateProducts();
            return _this.photosphereManager.getPhotospheres(10000, 0, _this.nurseryUUID, true);
        }), concatMap(function (photosphereList) {
            _this.photospheres = photosphereList.photospheres;
            _this.nurseries.push(photosphereList.photospheres[0].nursery);
            if (!_this.isBack && (!_this.photospheres || _this.photospheres.length === 0)) {
                _this.alertUtils.showErrorAlert("SPHERES_COMPONENT_EMPTY_ERROR_TITLE", "SPHERES_COMPONENT_EMPTY_ERROR_DESC");
            }
            return _this.photosphereManager.getPromotions(10000, 0, _this.nurseryUUID, null);
        }))
            .subscribe(function (promotionList) {
            _this.promotions = promotionList.promotions;
            if (_this.photospheres && _this.photospheres.length > 0) {
                photosphere.start(_this.photospheres.map(function (el) {
                    var newEl = {
                        uuid: el.uuid,
                        name: el.name,
                        yaw: el.yaw,
                        media: el.mediaURL,
                        latitude: el.latitude,
                        longitude: el.longitude,
                        markers: undefined
                    };
                    if (el.markers) {
                        newEl.markers = [];
                        el.markers.forEach(function (marker) {
                            // add all markers when in backoffice, don't show disabled ones in frontoffice
                            if (_this.isBack || marker.enabled) {
                                var calculatedPitch = (marker.markerType === MARKER_TYPE_PRODUCT
                                    && marker.pitch === -10)
                                    ? marker.pitch + PRODUCT_MARKER_PITCH_OFFSET
                                    : marker.pitch;
                                newEl.markers.push({
                                    uuid: marker.uuid,
                                    markerType: marker.markerType,
                                    yaw: marker.yaw,
                                    pitch: calculatedPitch,
                                    distance: marker.distance,
                                    product: marker.product,
                                    linkedPhotosphere: marker.linkedPhotosphereUUID,
                                    enabled: marker.enabled,
                                    promotionUuid: marker.promotionUuid
                                });
                            }
                        });
                        if (_this.isBack) {
                            newEl.markers.push({
                                uuid: "north",
                                markerType: MARKER_TYPE_NORTH,
                                yaw: 0,
                                pitch: -30,
                                distance: 0,
                                product: {
                                    varDex: 0
                                },
                                linkedPhotosphere: null,
                                enabled: true
                            });
                        }
                    }
                    return newEl;
                }), function (position) {
                    switch (_this.currentAction) {
                        case SPHERE_ACTION_PLANT:
                            _this.addMarker(position, MARKER_TYPE_PRODUCT);
                            break;
                        case SPHERE_ACTION_PROMO:
                            _this.addMarker(position, MARKER_TYPE_PROMO);
                            break;
                        case SPHERE_ACTION_CHANGE_MARKER:
                            if (_this.markerToChangeUuid != null) {
                                if (_this.markerToChangeLinkedPhotosphereUuid !== null) {
                                    _this.addMarker(position, MARKER_TYPE_PHOTOSPHERE);
                                }
                                else if (_this.markerToChangePromotion) {
                                    _this.addMarker(position, MARKER_TYPE_PROMO);
                                }
                                else {
                                    _this.addMarker(position, MARKER_TYPE_PRODUCT);
                                }
                            }
                    }
                }, _this.sphereUUID);
            }
        });
        this.backButtons.push({
            tag: SPHERE_ACTION_CHANGE_MARKER,
            image: "assets/img/near_me-24px.svg",
            text: "PHOTOSPHERE_COMPONENT_BTN_CHANGE_MARKER",
            background: SPHERE_BTN_BLUE,
            disabled: false,
            tempDisable: false
        });
        this.backButtons.push({
            tag: SPHERE_ACTION_PLANT,
            image: "assets/img/nature-24px.svg",
            text: "PHOTOSPHERE_COMPONENT_BTN_PLANT",
            background: SPHERE_BTN_GREEN,
            disabled: false,
            tempDisable: false
        });
        this.backButtons.push({
            tag: SPHERE_ACTION_PROMO,
            image: "assets/img/ic_promo.png",
            text: "PHOTOSPHERE_COMPONENT_BTN_PROMO",
            background: SPHERE_BTN_YELLOW,
            disabled: false,
            tempDisable: false
        });
        this.backButtons.push({
            tag: SPHERE_ACTION_ARROWS,
            image: "assets/img/ic_control_camera.png",
            text: "PHOTOSPHERE_COMPONENT_BTN_ARROWS",
            background: SPHERE_BTN_GRAY,
            disabled: false,
            tempDisable: false
        });
        this.backButtons.push({
            tag: SPHERE_ACTION_REMOVE,
            image: "assets/img/clear-24px.svg",
            text: "PHOTOSPHERE_COMPONENT_BTN_REMOVE",
            background: SPHERE_BTN_RED,
            disabled: false,
            tempDisable: false
        });
        this.backButtons.push({
            tag: SPHERE_ACTION_SHORTCUT,
            image: "assets/img/ic_star.svg",
            text: "PHOTOSPHERE_COMPONENT_BTN_SHORTCUTS",
            background: SPHERE_BTN_YELLOW,
            disabled: false,
            tempDisable: false
        });
        this.backButtons.push({
            tag: SPHERE_ACTION_CORRECT,
            image: "assets/img/ic_photosphere.png",
            text: "PHOTOSPHERE_COMPONENT_BTN_CORRECT",
            background: SPHERE_BTN_YELLOW,
            disabled: false,
            tempDisable: false
        });
        this.backButtons.push({
            tag: SPHERE_ACTION_PRODUCT_LINK,
            image: "assets/img/nature-24px.svg",
            text: "PHOTOSPHERE_COMPONENT_BTN_PRODUCT_LINK",
            background: SPHERE_BTN_BLUE,
            disabled: false,
            tempDisable: false
        });
        photosphere.setMarkerEditListener(function (markerUUID) {
            var language = _this.photosphereManager.getCurrentLanguage();
            _this.photospheres.forEach(function (ps) {
                if (ps.uuid === photosphere.getCurrentSceneUUID()) {
                    ps.markers.forEach(function (marker) {
                        if (marker.uuid === markerUUID) {
                            if (_this.currentAction === SPHERE_ACTION_PLANT
                                && marker.markerType === MARKER_TYPE_PRODUCT) {
                                _this.isEditing = photosphere.toggleEditMode();
                                _this.isEditingMarker = true;
                                _this.backButtons.forEach(function (el) {
                                    el.disabled = true;
                                });
                                _this.editedMarkerUUID = marker.uuid;
                                if (marker.product) {
                                    _this.photosphereManager.getProductInfo(marker.product.speCod, marker.product.varCod)
                                        .subscribe(function (productInfo) {
                                        _this.handleProductMeasures(productInfo);
                                        if (marker.productMeasure) {
                                            var measures = JSON.parse(marker.productMeasure);
                                            var measureModels = [];
                                            if (measures.length !== undefined && measures.length > 0) {
                                                measureModels = measures.map(function (element) { return new MeasureInfoModel(element); });
                                            }
                                            _this.checkSelectedProductMeasure(measureModels);
                                        }
                                    });
                                    _this.currentMarkerName = _this.getProductName(marker.product, language);
                                    _this.markerSelectedProduct = [
                                        marker.product
                                    ];
                                    _this.translateProducts();
                                }
                                return;
                            }
                            else if (_this.currentAction === SPHERE_ACTION_PROMO
                                && marker.markerType === MARKER_TYPE_PROMO) {
                                _this.isEditing = photosphere.toggleEditMode();
                                _this.isEditingPromoMarker = true;
                                _this.backButtons.forEach(function (el) {
                                    el.disabled = true;
                                });
                                _this.editedMarkerUUID = marker.uuid;
                                if (marker.promotionUuid) {
                                    _this.markerSelectedPromotion = _this.promotions.filter(function (promo) { return promo.uuid === marker.promotionUuid; });
                                    marker.promotion = (_this.markerSelectedPromotion[0])
                                        ? _this.markerSelectedPromotion[0]
                                        : null;
                                    _this.currentMarkerName = (_this.markerSelectedPromotion[0])
                                        ? _this.markerSelectedPromotion[0].title
                                        : "";
                                }
                                return;
                            }
                            else if (_this.currentAction === SPHERE_ACTION_ARROWS
                                && marker.markerType === MARKER_TYPE_PHOTOSPHERE
                                && !_this.isEditingArrow) {
                                _this.toggleArrow(marker.uuid);
                                return;
                            }
                            else if (_this.currentAction === SPHERE_ACTION_CHANGE_MARKER
                                && marker.markerType === MARKER_TYPE_PHOTOSPHERE) {
                                _this.markerToChangeUuid = marker.uuid;
                                _this.markerToChangeLinkedPhotosphereUuid = marker.linkedPhotosphereUUID;
                                _this.markerToChangeEnabled = marker.enabled;
                                photosphere.setLinkMarkerEnabled(marker.uuid, true);
                            }
                            else if (_this.currentAction === SPHERE_ACTION_CHANGE_MARKER
                                && marker.markerType === MARKER_TYPE_PRODUCT) {
                                _this.markerToChangeUuid = marker.uuid;
                                _this.markerToChangeLinkedPhotosphereUuid = null;
                                _this.markerToChangeEnabled = marker.enabled;
                                _this.markerToChangeProduct = marker.product;
                                photosphere.setLinkMarkerEnabled(marker.uuid, true);
                            }
                            else if (_this.currentAction === SPHERE_ACTION_CHANGE_MARKER
                                && marker.markerType === MARKER_TYPE_PROMO) {
                                _this.markerToChangeUuid = marker.uuid;
                                _this.markerToChangeLinkedPhotosphereUuid = null;
                                _this.markerToChangeEnabled = marker.enabled;
                                _this.markerToChangePromotion = marker.promotionUuid;
                                photosphere.setLinkMarkerEnabled(marker.uuid, true);
                            }
                        }
                    });
                    return;
                }
            });
        });
        photosphere.setMediaRequestListener(function (uuid, switchScene) {
            _this.photosphereManager.getPhotosphereMedia(uuid)
                .pipe(map(function (medias) {
                if (medias.medias) {
                    var mediaURL = medias.medias[0].getMediaURL("view_fhd");
                    if (mediaURL) {
                        photosphere.onMediaReceived(uuid, mediaURL.replace("{?res}", ""), switchScene);
                    }
                }
            }))
                .subscribe();
        });
        photosphere.setInfoMarkerOpenListener(function (uuid) {
            var speCod;
            var varCod;
            var idCod;
            var productMeasure;
            var promotion;
            _this.photospheres.forEach(function (ps) {
                if (ps.uuid === photosphere.getCurrentSceneUUID()) {
                    ps.markers.forEach(function (marker) {
                        if (marker.uuid === uuid) {
                            speCod = marker.product ? marker.product.speCod : null;
                            varCod = marker.product ? marker.product.varCod : null;
                            idCod = marker.product ? marker.product.uuid : null;
                            productMeasure = marker.productMeasure ? marker.productMeasure : null;
                            promotion = marker.promotionUuid
                                ? _this.promotions.find(function (promo) { return promo.uuid === marker.promotionUuid; })
                                : null;
                        }
                    });
                }
            });
            if (speCod && varCod) {
                _this.photosphereManager.getProductInfo(speCod, varCod)
                    .subscribe(function (productInfo) {
                    var language = _this.photosphereManager.getCurrentLanguage();
                    var desc = "";
                    desc += "<b>" +
                        _this.getProductName(productInfo.variety, language) + "</b><br/><br/>";
                    if (productMeasure) {
                        var measures = JSON.parse(productMeasure);
                        var productMeasureObjs_1 = [];
                        if (measures.length !== undefined && measures.length > 0) {
                            productMeasureObjs_1 = measures.map(function (element) { return new MeasureInfoModel(element); });
                        }
                        productMeasureObjs_1.forEach(function (productMeasureObj, index) {
                            productMeasureObj = _this.handleProductMeasuresDesc(productMeasureObj, true, index === 0);
                            desc += productMeasureObj.customText +
                                (index === productMeasureObjs_1.length - 1 ? "<br/>" : "");
                        });
                    }
                    if (productInfo.botanic) {
                        productInfo.botanic.forEach(function (info) {
                            desc += "<b>" + info.par + "</b>: " + info.val + "<br/>";
                        });
                    }
                    if (productInfo.variety.detailUrl) {
                        if (language === undefined || language === null
                            || (language !== LANG_CODE_EN && language !== LANG_CODE_IT && language !== LANG_CODE_FR)) {
                            language = LANG_CODE_EN;
                        }
                        language = (language === LANG_CODE_IT) ? PRODUCTS_LANG_CODE_IT :
                            ((language === LANG_CODE_EN) ? PRODUCTS_LANG_CODE_EN : PRODUCTS_LANG_CODE_FR);
                        desc += "<a class='btn w-100 my-2 info-hotspot-btn' " +
                            "target='_blank' href='" + productInfo.variety.detailUrl + "?lang=" + language + "'>" +
                            _this.translate.instant("SPHERES_COMPONENT_PRODUCT_DETAIL_BUTTON") + "</a>";
                    }
                    // Apply placeholder if no image
                    if (typeof productInfo.variety.imgPath == "undefined" || productInfo.variety.imgPath === "") {
                        productInfo.variety.imgPath = "/assets/img/product_placeholder.jpg";
                    }
                    photosphere.expandInfoMarker(uuid, productInfo.variety.imgPath, desc);
                    if (!_this.isBack) {
                        _this.logManager.addEvent(idCod, LOG_EVENT_PRODUCT)
                            .subscribe();
                    }
                });
            }
            else if (promotion != null) {
                var desc_1 = "<b>" + promotion.title.toUpperCase() + "</b><br/><br/>" + promotion.description;
                if (promotion.products && promotion.products.length > 0) {
                    desc_1 += "<br/><br/>" + _this.translate.instant("PROMOTION_EDIT_COMPONENT_PRODUCTS") + "<br/>";
                    promotion.products.forEach(function (item) {
                        desc_1 += item.product.varDex + "<br/>";
                    });
                }
                desc_1 += "<a class='btn w-100 my-2 info-hotspot-btn' href='mailto:contatti@giorgiotesigroup.it'>" +
                    _this.translate.instant("SPHERES_COMPONENT_PROMOTION_DETAIL_BUTTON") + "</a>";
                photosphere.expandInfoMarker(uuid, "assets/img/product_placeholder.jpg", desc_1);
                if (!_this.isBack) {
                    _this.logManager.addEvent(promotion.uuid, LOG_EVENT_PROMOTION)
                        .subscribe();
                }
            }
        });
        photosphere.setOnCreateProductMarker(function (marker, scene) {
            marker.product = _this.products.find(function (item) {
                return item.uuid === marker.product.uuid;
            });
            _this.photospheres.forEach(function (ps) {
                if (ps.uuid === scene.uuid) {
                    ps.markers.forEach(function (markerItem) {
                        if (markerItem.uuid === marker.uuid) {
                            markerItem.product = marker.product;
                        }
                    });
                }
            });
            photosphere.createProductInfoHotspotElement(marker, scene);
        });
        photosphere.setOnCreatePromotionMarker(function (marker, scene) {
            var promo = _this.promotions.find(function (item) {
                return item.uuid === marker.promotionUuid;
            });
            if (promo) {
                marker.promotion = promo;
                photosphere.createProductInfoHotspotElement(marker, scene);
            }
        });
        // LOG EVENT
        // eslint-disable-next-line
        photosphere.setOnSceneChanged(function (scene) {
            _this.currentPhotosphereUuid = scene.uuid;
            var latlng = new google.maps.LatLng(scene.latitude, scene.longitude);
            _this.map.setCenter(latlng);
            _this.marker.setPosition(latlng);
            if (!_this.isBack) {
                _this.logManager.addEvent(scene.uuid, LOG_EVENT_PHOTOSPHERE)
                    .subscribe();
            }
        });
    };
    PhotosphereComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    PhotosphereComponent.prototype.onBackButtonClick = function (tag) {
        if (this.isEditing && tag !== this.currentAction) {
            this.isEditing = photosphere.toggleEditMode();
        }
        this.fakeDisableAllMarkers(false);
        this.currentAction = tag;
        switch (tag) {
            case SPHERE_ACTION_CHANGE_MARKER:
                this.handleChangeMarker();
                break;
            case SPHERE_ACTION_PLANT:
                this.isEditing = photosphere.toggleEditMode();
                break;
            case SPHERE_ACTION_PROMO:
                this.isEditing = photosphere.toggleEditMode();
                break;
            case SPHERE_ACTION_ARROWS:
                this.isEditing = photosphere.toggleEditMode();
                break;
            case SPHERE_ACTION_REMOVE:
                this.handleDeletePhotosphere();
                break;
            case SPHERE_ACTION_SHORTCUT:
                this.handleShortcutsSection();
                break;
            case SPHERE_ACTION_CORRECT:
                this.isEditing = photosphere.toggleEditMode();
                break;
            case SPHERE_ACTION_PRODUCT_LINK:
                this.handleProductLink();
                break;
        }
    };
    PhotosphereComponent.prototype.handleShortcutsSection = function () {
        var _this = this;
        this.isEditing = photosphere.toggleEditMode();
        this.isEditingShortcuts = this.isEditing;
        if (this.isEditingShortcuts) {
            this.shortcutPhotosphere = photosphere.getCurrentSceneUUID();
        }
        this.backButtons.forEach(function (el) {
            el.disabled = _this.isEditingShortcuts;
        });
    };
    PhotosphereComponent.prototype.handleArrowsSection = function () {
        this.toggleArrow();
    };
    PhotosphereComponent.prototype.handleChangeMarker = function () {
        this.isEditing = photosphere.toggleEditMode();
        this.isEditingChangeMarker = this.isEditing;
        this.fakeDisableAllMarkers(this.isEditingChangeMarker);
        if (!this.isEditingChangeMarker) {
            this.markerToChangeUuid = null;
            this.markerToChangeLinkedPhotosphereUuid = null;
            this.markerToChangeEnabled = null;
            this.markerToChangeProduct = null;
            this.markerToChangePromotion = null;
        }
    };
    PhotosphereComponent.prototype.handleProductLink = function () {
        var _this = this;
        this.isEditing = photosphere.toggleEditMode();
        this.isEditingProductLink = !this.isEditingProductLink;
        if (this.isEditingProductLink) {
            var currentPhotosphere = this.photospheres.find(function (item) {
                return item.uuid === _this.currentPhotosphereUuid;
            });
            this.editedProductLink = currentPhotosphere.products[0];
            var language = this.photosphereManager.getCurrentLanguage();
            if (this.editedProductLink !== undefined && this.editedProductLink !== null) {
                this.editedProductLink.name = this.getProductName(this.editedProductLink, language);
            }
        }
        else {
            this.editedProductLink = null;
        }
    };
    PhotosphereComponent.prototype.onMarkerDelete = function () {
        var _this = this;
        if (this.editedMarkerUUID.includes("TEMP")) {
            this.isEditing = photosphere.toggleEditMode();
            this.isEditingMarker = false;
            this.isEditingPromoMarker = false;
            this.backButtons.forEach(function (el) {
                el.disabled = false;
            });
            this.isNewPromo = false;
            photosphere.deleteMarker(this.editedMarkerUUID);
        }
        else {
            if (!this.isNewPromo) {
                this.appComponent.startLoading();
                this.photosphereManager.deleteMarker(this.editedMarkerUUID)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                    .subscribe(function () {
                    _this.isEditing = photosphere.toggleEditMode();
                    _this.isEditingMarker = false;
                    _this.isEditingPromoMarker = false;
                    _this.backButtons.forEach(function (el) {
                        el.disabled = false;
                    });
                    photosphere.deleteMarker(_this.editedMarkerUUID);
                });
            }
            else {
                this.isEditing = photosphere.toggleEditMode();
                this.isEditingMarker = false;
                this.isEditingPromoMarker = false;
                this.backButtons.forEach(function (el) {
                    el.disabled = false;
                });
                this.isNewPromo = false;
            }
        }
    };
    PhotosphereComponent.prototype.onMarkerSave = function () {
        var _this = this;
        var markerIndex;
        var sphereIndex;
        var sphereUUID = photosphere.getCurrentSceneUUID();
        this.photospheres.forEach(function (el, elInd) {
            if (sphereUUID === el.uuid) {
                sphereIndex = elInd;
                el.markers.forEach(function (mk, mkInd) {
                    if (mk.uuid === _this.editedMarkerUUID) {
                        markerIndex = mkInd;
                        return;
                    }
                });
                return;
            }
        });
        if (sphereIndex !== undefined && markerIndex !== undefined) {
            this.appComponent.startLoading();
            var marker = {
                "marker_type": this.photospheres[sphereIndex].markers[markerIndex].markerType,
                "position_yaw": undefined,
                "position_pitch": undefined,
                "position_distance": undefined,
                "favourite": false,
                "enabled": true,
                "photosphere_uuid": this.photospheres[sphereIndex].uuid,
                "product_id_cod": (this.markerSelectedProduct && this.markerSelectedProduct[0])
                    ? this.markerSelectedProduct[0].uuid
                    : undefined,
                "linked_photosphere_uuid": null,
                "promotion_uuid": (this.markerSelectedPromotion && this.markerSelectedPromotion[0])
                    ? this.markerSelectedPromotion[0].uuid
                    : undefined,
                "product_info": (this.selectedProductMeasure && this.selectedProductMeasure[0] !== undefined)
                    ? JSON.stringify(this.selectedProductMeasures.filter(function (measure) {
                        var found = false;
                        _this.selectedProductMeasure.forEach(function (element) {
                            found = found === false ? measure.id === element.id : found;
                        });
                        return found;
                    })) : JSON.stringify({})
            };
            if (this.editedMarkerUUID.includes("TEMP")) {
                // eslint-disable-next-line
                marker.position_yaw = (this.photospheres[sphereIndex].markers[markerIndex].yaw + photosphere.getCurrentScene().yaw + 360) % 360;
                // eslint-disable-next-line
                marker.position_pitch = this.photospheres[sphereIndex].markers[markerIndex].pitch;
                // eslint-disable-next-line
                marker.position_distance = this.photospheres[sphereIndex].markers[markerIndex].distance;
                this.photosphereManager.addMarker(marker)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                    .subscribe(function (markerModel) {
                    _this.isEditing = photosphere.toggleEditMode();
                    _this.isEditingMarker = false;
                    _this.isEditingPromoMarker = false;
                    _this.isNewPromo = false;
                    _this.backButtons.forEach(function (el) {
                        el.disabled = false;
                    });
                    _this.photospheres[sphereIndex].markers[markerIndex] = markerModel;
                    _this.resetMarkerSelections();
                    photosphere.deleteMarker(_this.editedMarkerUUID);
                    photosphere.addMarker({
                        uuid: markerModel.uuid,
                        markerType: markerModel.markerType,
                        yaw: markerModel.yaw,
                        pitch: markerModel.pitch,
                        linkedPhotosphere: undefined,
                        product: markerModel.product,
                        promotionUuid: markerModel.promotionUuid
                    }, false);
                });
            }
            else {
                this.photosphereManager.updateMarker(this.editedMarkerUUID, marker)
                    .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                    .subscribe(function (markerModel) {
                    _this.isEditing = photosphere.toggleEditMode();
                    _this.isEditingMarker = false;
                    _this.isEditingPromoMarker = false;
                    _this.isNewPromo = false;
                    _this.backButtons.forEach(function (el) {
                        el.disabled = false;
                    });
                    _this.photospheres[sphereIndex].markers[markerIndex] = markerModel;
                    _this.resetMarkerSelections();
                    photosphere.deleteMarker(_this.editedMarkerUUID);
                    var calculatedPitch = (markerModel.markerType === MARKER_TYPE_PRODUCT && markerModel.pitch === -10)
                        ? markerModel.pitch + PRODUCT_MARKER_PITCH_OFFSET
                        : markerModel.pitch;
                    photosphere.addMarker({
                        uuid: markerModel.uuid,
                        markerType: markerModel.markerType,
                        yaw: markerModel.yaw,
                        pitch: calculatedPitch,
                        linkedPhotosphere: undefined,
                        product: markerModel.product,
                        promotionUuid: markerModel.promotionUuid
                    }, false);
                });
            }
        }
    };
    PhotosphereComponent.prototype.resetMarkerSelections = function () {
        this.markerSelectedProduct = null;
        this.markerSelectedPromotion = null;
        this.selectedProductMeasure = null;
        this.selectedProductMeasures = null;
    };
    PhotosphereComponent.prototype.onNewPromotion = function () {
        this.isNewPromo = true;
    };
    PhotosphereComponent.prototype.addMarker = function (position, markerType) {
        var _this = this;
        var marker = photosphere.addMarker({
            uuid: "TEMP" + new Date().getTime(),
            markerType: markerType,
            yaw: position.yaw * 180 / Math.PI,
            pitch: position.pitch * 180 / Math.PI,
            linkedPhotosphere: markerType ===
                MARKER_TYPE_PHOTOSPHERE ? this.markerToChangeLinkedPhotosphereUuid : undefined,
            linkedProduct: undefined,
            enabled: (markerType === MARKER_TYPE_PHOTOSPHERE ||
                markerType === MARKER_TYPE_PRODUCT ||
                markerType === MARKER_TYPE_PROMO)
                ? (this.markerToChangeEnabled != null ? this.markerToChangeEnabled : true)
                : undefined
        }, markerType === MARKER_TYPE_PHOTOSPHERE);
        if (marker.hotspot) {
            this.photospheres.forEach(function (ps) {
                if (ps.uuid === photosphere.getCurrentSceneUUID()) {
                    if (!ps.markers) {
                        ps.markers = [];
                    }
                    ps.markers.push({
                        uuid: marker.uuid,
                        markerType: marker.markerType,
                        yaw: marker.yaw,
                        pitch: marker.pitch,
                        linkedPhotosphereUUID: markerType ===
                            MARKER_TYPE_PHOTOSPHERE ? _this.markerToChangeLinkedPhotosphereUuid : undefined,
                        distance: undefined,
                        product: undefined,
                        enabled: true,
                        promotionUuid: undefined,
                        productMeasure: undefined
                    });
                    if (markerType === MARKER_TYPE_PRODUCT) {
                        if (_this.markerToChangeUuid != null) {
                            marker.product = _this.markerToChangeProduct;
                            _this.changeMarker(_this.markerToChangeUuid, marker);
                        }
                        else {
                            _this.isEditing = photosphere.toggleEditMode();
                            _this.isEditingMarker = true;
                            _this.backButtons.forEach(function (el) {
                                el.disabled = true;
                            });
                            _this.currentMarkerName = _this.translate
                                .instant("PHOTOSPHERE_COMPONENT_MARKER_EDIT_TITLE");
                            _this.editedMarkerUUID = marker.uuid;
                            _this.markerSelectedProduct = [];
                        }
                    }
                    else if (markerType === MARKER_TYPE_PROMO) {
                        if (_this.markerToChangeUuid != null) {
                            marker.promotionUuid = _this.markerToChangePromotion;
                            _this.changeMarker(_this.markerToChangeUuid, marker);
                        }
                        else {
                            _this.isEditing = photosphere.toggleEditMode();
                            _this.isEditingPromoMarker = true;
                            _this.backButtons.forEach(function (el) {
                                el.disabled = true;
                            });
                            _this.currentMarkerName = _this.translate
                                .instant("PHOTOSPHERE_COMPONENT_MARKER_EDIT_TITLE");
                            _this.editedMarkerUUID = marker.uuid;
                            _this.markerSelectedPromotion = [];
                        }
                    }
                    else if (markerType === MARKER_TYPE_PHOTOSPHERE) {
                        _this.changeMarker(_this.markerToChangeUuid, marker);
                    }
                    return;
                }
            });
        }
    };
    PhotosphereComponent.prototype.onPromoClick = function (uuid) {
        var _this = this;
        if (this.isEditing && this.currentAction === SPHERE_ACTION_PROMO) {
            this.togglePromo();
            this.editedPromoUUID = uuid;
            var _loop_1 = function (promo) {
                if (promo.uuid === uuid) {
                    this_1.editedPromo = promo;
                    var language_1 = this_1.photosphereManager.getCurrentLanguage();
                    this_1.editedPromo.products = this_1.editedPromo.products.map(function (product) {
                        product.product.name = _this.getProductName(product.product, language_1);
                        return product;
                    });
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = this.promotions; _i < _a.length; _i++) {
                var promo = _a[_i];
                _loop_1(promo);
            }
        } /* else if(!this.isBack) {
            this.logManager.addEvent(uuid, LOG_EVENT_PROMOTION)
                .subscribe();
        }*/
    };
    PhotosphereComponent.prototype.togglePromo = function () {
        var _this = this;
        this.isEditing = photosphere.toggleEditMode();
        this.isEditingPromo = !this.isEditingPromo;
        this.backButtons.forEach(function (el) {
            el.disabled = _this.isEditingPromo;
        });
    };
    PhotosphereComponent.prototype.toggleArrow = function (markerUUID) {
        var _this = this;
        this.editedArrowUUID = markerUUID;
        this.isEditingArrow = !this.isEditingArrow;
        this.backButtons.forEach(function (el) {
            el.disabled = _this.isEditingArrow;
        });
    };
    PhotosphereComponent.prototype.onProductLinkClose = function () {
        this.handleProductLink();
    };
    PhotosphereComponent.prototype.onProductLinkDelete = function () {
        var _this = this;
        this.alertUtils.showConfirmAlert("PHOTOSPHERE_COMPONENT_DELETE_PRODUCT_LINK_CONFIRM_TITLE_ALERT", "PHOTOSPHERE_COMPONENT_DELETE_PRODUCT_LINK_CONFIRM_TEXT_ALERT", function () {
            _this.deleteProductLink();
        }, function () {
            logData("close");
        });
    };
    PhotosphereComponent.prototype.deleteProductLink = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.disassociatePhotosphereProducts(this.currentPhotosphereUuid)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (photosphereModel) {
            var index = _this.photospheres.indexOf(_this.photospheres.find(function (item) {
                return item.uuid === _this.currentPhotosphereUuid;
            }));
            if (index !== -1) {
                _this.photospheres[index] = photosphereModel;
            }
            _this.handleProductLink();
        });
    };
    PhotosphereComponent.prototype.onProductLinkSave = function (res) {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.associatePhotosphereProduct(this.currentPhotosphereUuid, res.product.uuid)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (photosphereModel) {
            var index = _this.photospheres.indexOf(_this.photospheres.find(function (item) {
                return item.uuid === _this.currentPhotosphereUuid;
            }));
            if (index !== -1) {
                _this.photospheres[index] = photosphereModel;
            }
            _this.handleProductLink();
        });
    };
    PhotosphereComponent.prototype.onPromoDelete = function () {
        var _this = this;
        if (this.editedPromoUUID) {
            this.appComponent.startLoading();
            this.photosphereManager.deletePromotion(this.editedPromoUUID)
                .pipe(finalize(function () { return _this.appComponent.stopLoading(); }), concatMap(function (result) { return _this.photosphereManager.getPromotions(10000, 0, _this.nurseryUUID, null)
                .pipe(map(function (promos) {
                _this.promotions = promos.promotions;
                return result;
            })); }))
                .subscribe(function () {
                _this.togglePromo();
            });
        }
        else {
            this.togglePromo();
        }
    };
    PhotosphereComponent.prototype.onPromoSave = function (res) {
        var _this = this;
        this.appComponent.startLoading();
        if (!this.editedPromoUUID) {
            this.photosphereManager.addPromotion({ title: res.title, description: res.description, featured: res.featured }, { products: res.products.map(function (prod) { return prod.uuid; }) }, { nurseries: res.nurseries.map(function (nursery) { return nursery.uuid; }) }, null)
                .pipe(finalize(function () { return _this.appComponent.stopLoading(); }), concatMap(function (result) { return _this.photosphereManager.getPromotions(10000, 0, _this.nurseryUUID, null)
                .pipe(map(function (promos) {
                _this.promotions = promos.promotions;
                return result;
            })); }))
                .subscribe(function (newPromo) {
                _this.markerSelectedPromotion = [
                    newPromo
                ];
                _this.onMarkerSave();
            });
        }
    };
    PhotosphereComponent.prototype.onPromoNew = function () {
        this.togglePromo();
        this.editedPromoUUID = undefined;
        this.editedPromo = undefined;
    };
    /* eslint-disable camelcase, @typescript-eslint/camelcase */
    PhotosphereComponent.prototype.onArrowSave = function (enabled) {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.updateMarker(this.editedArrowUUID, {
            marker_type: undefined,
            position_yaw: undefined,
            position_pitch: undefined,
            position_distance: undefined,
            favourite: undefined,
            enabled: enabled,
            photosphere_uuid: undefined,
            product_id_cod: undefined,
            linked_photosphere_uuid: undefined,
            promotion_uuid: undefined,
            product_info: undefined
        })
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function () {
            _this.photospheres.forEach(function (ps) {
                if (ps.uuid === photosphere.getCurrentSceneUUID()) {
                    if (ps.markers) {
                        ps.markers.forEach(function (marker) {
                            if (marker && marker.uuid === _this.editedArrowUUID) {
                                marker.enabled = enabled;
                            }
                        });
                    }
                }
            });
            photosphere.setLinkMarkerEnabled(_this.editedArrowUUID, enabled);
            _this.toggleArrow();
        });
    };
    PhotosphereComponent.prototype.onShowShortcut = function (event) {
        var _this = this;
        photosphere.changeSphereById(event);
        this.isEditing = photosphere.toggleEditMode();
        this.isEditingShortcuts = !this.isEditingShortcuts;
        this.backButtons.forEach(function (el) {
            el.disabled = _this.isEditingShortcuts;
        });
    };
    PhotosphereComponent.prototype.handleDeletePhotosphere = function () {
        var _this = this;
        this.isEditing = photosphere.toggleEditMode();
        this.alertUtils.showConfirmAlert("PHOTOSPHERE_COMPONENT_DELETE_CONFIRM_TITLE_ALERT", "PHOTOSPHERE_COMPONENT_DELETE_CONFIRM_TEXT_ALERT", function () {
            _this.deletePhotosphere();
        }, function () {
            _this.isEditing = photosphere.toggleEditMode();
        });
    };
    PhotosphereComponent.prototype.deletePhotosphere = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.deletePhotosphere(photosphere.getCurrentSceneUUID())
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function () {
            _this.genericService.onGoBackCalled.emit();
        });
    };
    PhotosphereComponent.prototype.changeMarker = function (markerToChangeUuid, marker) {
        var _this = this;
        this.appComponent.startLoading();
        // logData("onmarker edit", (marker.yaw));
        // logData("onmarker edit", (marker.yaw + photosphere.getCurrentScene().yaw + 360) % 360);
        // const pitch = (marker.markerType === MARKER_TYPE_PRODUCT || marker.markerType === MARKER_TYPE_PROMO)
        //            ? marker.pitch - PRODUCT_MARKER_PITCH_OFFSET
        //            : marker.pitch;
        this.photosphereManager.updateMarker(markerToChangeUuid, {
            "marker_type": undefined,
            "position_yaw": (marker.yaw + photosphere.getCurrentScene().yaw + 360) % 360,
            "position_pitch": marker.pitch,
            "position_distance": marker.distance,
            "favourite": undefined,
            "enabled": undefined,
            "photosphere_uuid": undefined,
            "product_id_cod": undefined,
            "linked_photosphere_uuid": undefined,
            "promotion_uuid": undefined,
            "product_info": undefined
        })
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (markerModel) {
            photosphere.deleteMarker(markerToChangeUuid);
            marker.uuid = markerModel.uuid;
            photosphere.deleteMarker(marker.uuid);
            marker.yaw = markerModel.yaw;
            photosphere.addMarker(marker, true);
            _this.handleChangeMarker();
            _this.backButtons.forEach(function (el) {
                el.disabled = false;
            });
        });
    };
    PhotosphereComponent.prototype.onCorrectYawClick = function () {
        var _this = this;
        // const clickedMarkerYaw = photosphere.getClickedMarkerYaw() != null ? photosphere.getClickedMarkerYaw() : 0;
        // logData("current view yaw", photosphere.getCurrentViewYaw());
        // logData("starting view yaw", clickedMarkerYaw);
        var photosphereItem = {
            "yaw": (-photosphere.getCurrentViewYaw() + 360) % 360
        };
        this.appComponent.startLoading();
        this.photosphereManager.updatePhotosphere(photosphere.getCurrentSceneUUID(), photosphereItem)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (photosphereModel) {
            _this.isEditing = photosphere.toggleEditMode();
            {
                var scene = getCurrentScene();
                var oldYaw = scene.yaw;
                var yawDiff_1 = photosphereModel.yaw - oldYaw;
                // logData("scene", scene);
                scene.markers.forEach(function (marker) {
                    if (marker.markerType === MARKER_TYPE_PHOTOSPHERE && marker.linkedPhotosphere) {
                        marker.yaw = ((marker.yaw + yawDiff_1) + 720) % 360;
                        _this.photosphereManager.updateMarker(marker.uuid, {
                            marker_type: undefined,
                            position_yaw: marker.yaw,
                            position_pitch: undefined,
                            position_distance: undefined,
                            favourite: undefined,
                            enabled: undefined,
                            photosphere_uuid: undefined,
                            product_id_cod: undefined,
                            linked_photosphere_uuid: undefined,
                            promotion_uuid: undefined,
                            product_info: undefined
                        }).subscribe();
                    }
                });
            }
            photosphere.updateCurrentSceneMarkers(photosphereModel.yaw);
        });
    };
    PhotosphereComponent.prototype.fakeDisableAllMarkers = function (disable) {
        this.photospheres.forEach(function (ps) {
            if (ps.uuid === photosphere.getCurrentSceneUUID()) {
                if (ps.markers) {
                    ps.markers.forEach(function (marker) {
                        if (marker && marker.markerType === MARKER_TYPE_PHOTOSPHERE) {
                            if (disable) {
                                photosphere.setLinkMarkerEnabled(marker.uuid, false);
                            }
                            else {
                                photosphere.setLinkMarkerEnabled(marker.uuid, marker.enabled);
                            }
                        }
                    });
                }
            }
        });
    };
    PhotosphereComponent.prototype.initDrawManager = function (gmap) {
        var _this = this;
        this.mapsAPILoader.load().then(function () {
            _this.map = gmap;
            _this.SPHERE_MARKER = {
                url: "/assets/img/ic_sphere_marker.png",
                scaledSize: new google.maps.Size(35, 35)
            };
            _this.SPHERE_MARKER_ACTIVE = {
                url: "/assets/img/ic_sphere_marker_active.png",
                scaledSize: new google.maps.Size(35, 35)
            };
            _this.marker = new google.maps.Marker({
                position: new google.maps.LatLng(_this.avgLat, _this.avgLong),
                icon: _this.SPHERE_MARKER
            });
            // eslint-disable-next-line
            // @ts-ignore
            _this.marker.setMap(_this.map);
        });
    };
    PhotosphereComponent.prototype.subscribeOnLangChange = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function (language) {
            _this.translateProducts(language.lang);
        });
    };
    PhotosphereComponent.prototype.translateProducts = function (language) {
        var _this = this;
        if (language === undefined || language === null) {
            language = this.photosphereManager.getCurrentLanguage();
        }
        if (this.products !== undefined) {
            this.products = this.products.map(function (product) {
                product.name = _this.getProductName(product, language);
                return product;
            });
        }
        if (this.markerSelectedProduct !== undefined) {
            this.markerSelectedProduct = this.markerSelectedProduct.map(function (product) {
                product.name = _this.getProductName(product, language);
                return product;
            });
        }
    };
    PhotosphereComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_NURSERY_MAP_ROUTE, { id: _this.nurseryUUID });
        });
    };
    PhotosphereComponent.prototype.unsubscribeServices = function () {
        if (this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    };
    PhotosphereComponent.prototype.onProductSelect = function (_) {
        var _this = this;
        this.selectedProductMeasures = null;
        this.selectedProductMeasure = null;
        if (this.markerSelectedProduct && this.markerSelectedProduct.length > 0) {
            var selectedProduct = this.products.find(function (item) { return item.uuid === _this.markerSelectedProduct[0].uuid; });
            this.photosphereManager.getProductInfo(selectedProduct.speCod, selectedProduct.varCod)
                .subscribe(function (productInfo) {
                _this.handleProductMeasures(productInfo);
            });
        }
    };
    PhotosphereComponent.prototype.handleProductMeasures = function (productInfo) {
        var _this = this;
        this.selectedProductMeasures = productInfo.measures.map(function (measure, index) {
            measure.id = index;
            return _this.handleProductMeasuresDesc(measure, false);
        });
    };
    PhotosphereComponent.prototype.handleProductMeasuresDesc = function (measure, isHtml, printHeader) {
        var customText = "";
        customText = customText + this.handleProductMeasureDesc(measure.altCod, measure.altDex, "PRODUCT_DETAIL_MEASURE_ALT", isHtml);
        customText = customText + this.handleProductMeasureDesc(measure.cirCod, measure.cirDex, "PRODUCT_DETAIL_MEASURE_CIR", isHtml);
        customText = customText + this.handleProductMeasureDesc(measure.cndCod, measure.cndDex, "PRODUCT_DETAIL_MEASURE_CND", isHtml);
        customText = customText + this.handleProductMeasureDesc(measure.mcoCod, measure.mcoDex, "PRODUCT_DETAIL_MEASURE_MCO", isHtml);
        customText = customText + this.handleProductMeasureDesc(measure.tipCod, measure.tipDex, "PRODUCT_DETAIL_MEASURE_TIP", isHtml);
        measure.customText = customText !== "" && isHtml && printHeader ?
            "<b><u>" + this.translate.instant("PRODUCT_DETAIL_MEASURES_PLACEHOLDER").toUpperCase() +
                "</u></b><br/>" + customText : customText;
        return measure;
    };
    PhotosphereComponent.prototype.handleProductMeasureDesc = function (measureFeatureCod, measureFeatureDex, measureLabel, isHtml) {
        var text = "";
        if (measureFeatureCod !== undefined && measureFeatureCod !== null && measureFeatureCod !== "" &&
            measureFeatureDex !== undefined && measureFeatureDex !== null && measureFeatureDex !== "") {
            var translatedLabel = isHtml ?
                this.translate.instant(measureLabel).toUpperCase() : this.translate.instant(measureLabel);
            text = (isHtml ? "<b>" : "") + translatedLabel + (isHtml ? "</b>" : "") + ": " +
                measureFeatureDex + (isHtml ? "<br/>" : " ");
        }
        return text;
    };
    PhotosphereComponent.prototype.checkSelectedProductMeasure = function (productMeasures) {
        this.selectedProductMeasure = this.selectedProductMeasures.filter(function (measure) {
            var found = false;
            productMeasures.forEach(function (element) {
                found = found === false ? measure.tipCod === element.tipCod &&
                    measure.tipDex === element.tipDex &&
                    measure.cndCod === element.cndCod &&
                    measure.cndDex === element.cndDex &&
                    measure.mcoCod === element.mcoCod &&
                    measure.mcoDex === element.mcoDex &&
                    measure.altCod === element.altCod &&
                    measure.altDex === element.altDex &&
                    measure.cirCod === element.cirCod &&
                    measure.cirDex === element.cirDex : found;
            });
            return found;
        });
    };
    return PhotosphereComponent;
}(BaseComponent));
export { PhotosphereComponent };
